import Vue from 'vue'
import App from './App.vue'
import '@/assets/css/tailwind.css'
import '@/assets/bootstrap-icons/bootstrap-icons.css'
import 'vue-select/dist/vue-select.css'
import './registerServiceWorker'
import router from './router'
import 'dayjs/locale/de'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
